import ChatMessage from './ChatMessage';

class SystemMessage extends ChatMessage {
  constructor(message) {
    super('system', message);
  }
}

export default SystemMessage;
